import base from './base';

export const text = (value: any) => base(value);
export default text;
